module.exports = __webpack_public_path__ + "static/img/4.40f5e6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/4.jpg
// module id = eyvb
// module chunks = 4